import { render } from "./TransactionStatusView.vue?vue&type=template&id=7626736e"
import script from "./TransactionStatusView.vue?vue&type=script&lang=js"
export * from "./TransactionStatusView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__